import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import API, { formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { SubClientOverview } from "../components/portal/SubClientOverview";
import { SubClientLinksProvider, adminLinks } from "../components/portal/SubClientCards";
import { EmptyState } from "../components/portal/PortalPage";
import { CardListSkeleton } from "../components/Skeletons";
import { ArrowLeft, ArrowSquareOut, Buildings, TreeStructure } from "@phosphor-icons/react";

/* Admin: one sub-client's full picture under its main client — the same oversight layout the main client sees in
   their portal, with rows linking to the admin record pages. */
export default function AdminSubClientOverviewPage() {
  const { clientId, subId } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  useEffect(() => {
    setData(null); setError("");
    API.get(`/clients/${clientId}/sub-clients/${subId}/overview`).then(({ data }) => setData(data)).catch((e) => setError(formatApiError(e?.response?.data?.detail) || "Could not load this sub-client"));
  }, [clientId, subId]);

  const c = data?.client;
  return (
    <SubClientLinksProvider links={adminLinks(clientId)}>
      <div className="max-w-7xl mx-auto animate-fade-in" data-testid="admin-sub-client-overview-page">
        <Link to={`/clients/${clientId}`} className="inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-primary mb-3" data-testid="admin-sub-client-back">
          <ArrowLeft size={14} /> Back to {c?.main_client?.display_name || "main client"}
        </Link>
        <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3 mb-6">
          <div className="min-w-0">
            <p className="text-[10px] uppercase tracking-[0.15em] text-violet-700 dark:text-violet-300 font-semibold inline-flex items-center gap-1"><TreeStructure size={12} /> Sub-client of {c?.main_client?.display_name || "…"}</p>
            <h1 className="text-2xl sm:text-3xl font-bold font-[Chivo] tracking-tight" data-testid="admin-sub-client-title">{c?.display_name || "Sub-client"}</h1>
            {c && <p className="text-sm text-muted-foreground mt-1">{[c.contact_name, c.email, c.portal_enabled ? "Portal enabled" : "Portal disabled"].filter(Boolean).join(" · ")}</p>}
          </div>
          {c && (
            <Button asChild size="sm" variant="outline" data-testid="admin-sub-client-open-record">
              <Link to={`/clients/${c.id}`}><ArrowSquareOut size={14} className="mr-1" /> Open client record</Link>
            </Button>
          )}
        </div>
        {error ? <EmptyState icon={Buildings} title="Not available" text={error} /> : !data ? <CardListSkeleton rows={4} showHeader={false} /> : <SubClientOverview data={data} viewAllLabel="Open all" />}
      </div>
    </SubClientLinksProvider>
  );
}
